@if (!isLoading) {
  <section class="main-content">
    <div class="row mt-3">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2">
              <div class="col-12">
                <full-calendar #fullCalendar [options]="calendarOptions"></full-calendar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
}

<ng-template [tuiDialogOptions]="{ closable: false, size: 'l', dismissible: false}" [(tuiDialog)]="isOpenPlatinumInstructionDialog">
  <tui-loader class="loader" [inheritColor]="isLoadingPlatinumInstructionDialog"
    [overlay]="isLoadingPlatinumInstructionDialog" [loading]="isLoadingPlatinumInstructionDialog">
    <header class="header">
      <div class="col-12">
        <div class="title-flex">
          <h4 class="main-title">
            <span tuiAvatar="@tui.credit-card"  class="taga-icons"></span>
            <span class="mt-1 pad-left-10"> Platinum Instructions</span>
          </h4>
          <div class="text-end-container">
            <button iconStart="@tui.x" class="margin-left-10" appearance="outline" tuiIconButton
            (click)="closePlatinumInstDialog()" type="button" size="s" placement="right"></button>
          </div>
        </div>
      </div>
    </header>
    <div class="dialog-content">
      <hr class="title-line mt-1 mb-2">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <table class="table table-sm table-bordered mb-0">
            <thead>
              <tr>
                <td style="width: 60%;" class="table-secondary">
                  Account Manager Name
                </td>
                <td style="width: 40%;" class="table-secondary text-center">
                  Platinum Instructions (Not Complete)
                </td>
              </tr>
            </thead>
            <tbody>
              @for (row of selectedAMWiseData; track row) {
                <tr>
                  <td>
                    {{row.accountManagerName}}
                  </td>
                  <td class="text-center">
                    <a class="primary-color cursor-pointer" (click)="goToDueReport()">
                      {{row.platinumInstNotCompleteCount}}
                    </a>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </tui-loader>
</ng-template>